import styled from "styled-components";
import { Breakpoints } from "../../AppTheme";
import { CheckmarkFilterProps } from "../Filter.types";

export const StyledBooleanFilter = styled.span`
    @media ${Breakpoints.mobile} {
      margin-left: 0;
  }
`;

export const StyledBooleanFilterTooltip = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-left: 0.3125rem;
  cursor: help;
  vertical-align: middle;

  svg {
    display: block;
  }

  .tooltip-text {
    position: fixed;
    transform: translateX(-50%);
    z-index: 1000;
    width: max-content;
    max-width: 18rem;
    padding: 0.5rem 0.75rem;
    border: 1px solid #000;
    border-radius: 0.25rem;
    background-color: #fff;
    color: #000;
    font-size: 0.75rem;
    line-height: 1.4;
    white-space: normal;
    word-break: break-word;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;

    &::before,
    &::after {
      content: "";
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-left: 0.5rem solid transparent;
      border-right: 0.5rem solid transparent;
    }

    &::before {
      top: -0.75rem;
      border-bottom: 0.75rem solid #000;
    }

    &::after {
      top: -0.625rem;
      border-bottom: 0.75rem solid #fff;
    }

    &.tooltip-above::before,
    &.tooltip-above::after {
      top: auto;
      border-top: 0.75rem solid;
      border-bottom: 0;
    }

    &.tooltip-above::before {
      bottom: -0.75rem;
      border-top-color: #000;
    }

    &.tooltip-above::after {
      bottom: -0.625rem;
      border-top-color: #fff;
    }
  }

  &:hover .tooltip-text {
    opacity: 1;
    visibility: visible;
  }
`;
